"use client";
import { StrictMode } from "react";
import React from "react";

import * as ReactDOM from "react-dom/client";

import App from "./app/App";

import "@fontsource/inter";
import {
  GlobalStyles,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { globalStyles, theme } from "./assets/styles/theme";
import AuthProvider from "./app/context/AuthProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0 } },
});

root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={globalStyles} />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);
